import React from "react";
const BubbleHolder = ({ children, className }) => {
  return (
    <div className={`${className ? className : ""}`}>
      <div className="flex items-center h-full w-full">
        <div className="w-full pb-[100%] relative">
          <div className="absolute top-0 left-0 h-full w-full ">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default BubbleHolder;
